import React from 'react';
import I18n from 'i18n-js';

import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { RCText, useMediaQuery } from '@reverbdotcom/cadence/components';
import { SearchRemixer_FacetGroupFieldsFragment } from '@reverbdotcom/commons/src/gql/graphql';
import { Paths } from '@reverbdotcom/commons/src/url_helpers';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { FacetGroup } from './facet_group';
import { isSomethingSelected, SHIPS_TO } from './facet';
import { FacetSidebar } from './facet_sidebar';
import FacetChipRow from './facet_chip_row';
import { displayShipsToByDefault } from './facets/region_select_facet';

interface IProps {
  facetGroups?: SearchRemixer_FacetGroupFieldsFragment[];
  loading?: boolean;
  query?: string;
  resultsTotal?: number;
}

export function FacetGroupRow({
  facetGroups = [],
  loading = false,
  query = '',
  resultsTotal = null,
}: IProps) {
  const isMobile = useMediaQuery('mobile');
  const user = useUser();
  const defaultFacetGroups = facetGroups.filter((fg) => fg.featured >= 0).sort((a, b) => (a.featured) - (b.featured));
  const otherSelectedFacetGroups = facetGroups.filter((fg) => {
    if (fg.key === SHIPS_TO) { return displayShipsToByDefault(fg, user.shippingRegionCode); }

    return fg.featured < 0 && fg.facets.some(f => isSomethingSelected(f, true));
  });

  return (
    <div className="search-overview__filters search-overview__filters--mobile">
      <FacetSidebar
        facetGroups={facetGroups}
        loading={loading}
        query={query}
        resultsTotal={resultsTotal}
      />
      {isMobile && <FacetChipRow facetGroups={facetGroups} />}
      {!isMobile &&
        <>
          {
            defaultFacetGroups.map(facetGroup => {
              return (
                <FacetGroup facetGroup={facetGroup} loading={loading} key={facetGroup.displayName} />
              );
            })
          }
          {
            otherSelectedFacetGroups.map(facetGroup => {
              return (
                <FacetGroup facetGroup={facetGroup} loading={loading} key={facetGroup.displayName} />
              );
            })
          }
          <ClearFacetsButton
            query={query}
            facetGroups={facetGroups}
            classNames="text-link plr-2 d-flex height-100 fx-align-center"
          />
        </>
      }
    </div>
  );
}

export function ClearFacetsButton({ query, facetGroups, classNames = '' }) {
  const anyFacetsSelected = facetGroups.some(fg => fg.facets.some(f => isSomethingSelected(f, true)));
  if (!anyFacetsSelected) { return null; }

  const clearedParams = query ? { query } : {};
  return (
    <div className="marketplace-filter">
      <CoreLink
        to={Paths.marketplaceV2.expand(clearedParams)}
        className={classNames}
      >
        <RCText.Utility size="350" weight="semibold" htmlTag="span">
          {I18n.t('commons.marketplaceFilters.clearFilters')}
        </RCText.Utility>
      </CoreLink>
    </div>
  );
}
